export default "__VITE_ASSET__CuLAoDdv__"